var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStyleFontNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#323C47",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16664 10.9997C5.7064 10.9997 5.3333 11.3728 5.3333 11.833C5.3333 12.2932 5.7064 12.6663 6.16664 12.6663H9.8333C10.2935 12.6663 10.6666 12.2932 10.6666 11.833C10.6666 11.3728 10.2935 10.9997 9.8333 10.9997H8.99992V4.99967H9.83329C10.2935 4.99967 10.6666 4.62659 10.6666 4.16635C10.6666 3.70611 10.2935 3.33301 9.83329 3.33301H6.16661C5.70636 3.33301 5.33326 3.70612 5.33328 4.16637C5.33329 4.62659 5.70638 4.99967 6.16661 4.99967H6.99992V10.9997H6.16664Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleFontNormal);
export default __webpack_public_path__ + "static/media/styleFontNormal.516f36db.svg";
export { ForwardRef as ReactComponent };